import { useState } from "react";
import Select from 'react-select';
import { useLoading } from "../../../../components/globalloaders/LoadingContext";
import { toast } from "react-toastify";
import { encryptPayload, formatCurrency } from "../../../../constants/helpers";
import api from "../../../../utils/auth/api";
import { agreementValidOptions } from "../../../../constants/options";

const AgreementAdd = ({ open, onClose, entry, onSuccess }) => {

    const { isLoading, setIsLoading } = useLoading();
    const initialState = {
        entryRef: "",
        validFor: "",
        refNo: "",
        salary: "",
        commission: "",
    };
    const [formData, setFormData] = useState(initialState);

    const handleClose = () => {
        setFormData(initialState);
        onClose();
    };

    const handleSelectChange = (selectedOption, { name }) => {
        setFormData({
            ...formData,
            [name]: selectedOption ? selectedOption.value : "",
        });
    };
    const handleNumberChange = (e) => {
        const { name, value } = e.target;
        const digits = value.replace(/\D/g, "");
        setFormData(prev => ({ ...prev, [name]: digits }));
    };
    const handleSubmit = async () => {
        if (isLoading) return;

        if (!entry) return toast.warning("Entry Ref required.");
        if (!formData.validFor) return toast.warning("Valid for required.");
        if (!formData.refNo) return toast.warning("Ref No required.");
        if (!formData.salary) return toast.warning("Salary required.");
        if (!formData.commission) return toast.warning("Commission required.");

        const payload = {
            entryRef: entry,
            validFor: formData.validFor,
            refNo: formData.refNo,
            salary: Number(formData.salary),
            commission: Number(formData.commission),
        };

        setIsLoading(true);
        try {
            const res = await api.post(`${process.env.REACT_APP_URI}/agreement/create`, { data: encryptPayload(payload) });
            if (res.data.success) {
                toast.success(res.data.message);
                if (typeof onSuccess === "function") {
                    onSuccess(res.data);
                }
                handleClose();
            } else {
                toast.error(res.data.message);
            }
        } catch (err) {
            console.log("Error creating agreement:", err);
            toast.error(err?.response.data.message || "Agreement creation failed.");
        } finally {
            setIsLoading(false);
            return;
        }
    };

    if (!open || !entry) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black/60 backdrop-blur-[2px] z-40 p-3">
            <div className="bg-white rounded-2xl w-full max-w-5xl max-h-[90vh] overflow-y-auto animate-fadeIn border border-gray-200">
                <div className="max-h-[85vh] flex flex-col">
                    <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white p-3 sm:p-4 shadow-md text-center">
                        <h2 className="text-xl sm:text-2xl font-bold">Create Agreement</h2>
                        <p className="text-[10px] sm:text-xs opacity-80">Smart by Logic. Built for You.</p>
                    </div>
                    <div className="flex-1 overflow-auto p-3 bg-gray-50">
                        <fieldset className="bg-white border p-4 rounded-lg">
                            <legend className="text-md sm:text-lg font-semibold text-gray-700 px-2">Info</legend>
                            <div className="grid grid-cols-1 gap-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Valid For</label>
                                    <Select
                                        name="validFor"
                                        options={agreementValidOptions}
                                        placeholder="Select Duration"
                                        value={agreementValidOptions.find(option => option.value === formData.validFor)}
                                        onChange={(selectedOption) =>
                                            handleSelectChange(selectedOption, { name: 'validFor' })
                                        }
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Ref No</label>
                                    <input className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-400 outline-none"
                                        placeholder="5XX"
                                        type="text"
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        name='refNo'
                                        value={formData.refNo}
                                        onChange={handleNumberChange}
                                    />
                                </div>

                                <div className="space-y-1">
                                    <label className="block text-sm font-medium text-gray-700">Salary</label>
                                    <div className="relative">
                                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm">
                                            PKR
                                        </span>
                                        <input
                                            className="w-full pl-12 pr-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-400 outline-none"
                                            placeholder="XX,XXX"
                                            type="text"
                                            name="salary"
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                            value={formatCurrency(formData.salary)}
                                            onChange={handleNumberChange}
                                        />
                                    </div>
                                </div>

                                <div className="space-y-1">
                                    <label className="block text-sm font-medium text-gray-700">Commission</label>
                                    <div className="relative">
                                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm">
                                            PKR
                                        </span>
                                        <input
                                            className="w-full pl-12 pr-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-400 outline-none"
                                            placeholder="XX,XXX"
                                            type="text"
                                            name="commission"
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                            value={formatCurrency(formData.commission)}
                                            onChange={handleNumberChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                    <div className="border-t p-2.5 sm:px-4 sm:py-2.5 flex justify-between">
                        <button
                            type='button'
                            onClick={() => handleClose()}
                            className="px-3 sm:px-4 py-2 rounded-lg text-sm sm:text-base font-medium text-gray-600 bg-gray-200 hover:bg-gray-300 transition"
                        >
                            Close
                        </button>
                        <button
                            type="button"
                            onClick={handleSubmit}
                            className="px-3 sm:px-4 py-2 rounded-lg text-sm sm:text-base bg-blue-600 text-white hover:bg-blue-700 transition"
                        >
                            Create
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AgreementAdd;